/* Spanish Language File */

var currentlanguage = 'es';

+function ($) {

	/* Spanish translation for the jQuery dataTable Addon */
	if ('undefined' !== typeof $.fn.dataTable) {
		$.extend( true, $.fn.dataTable.defaults, {
			"oLanguage": {
				"sProcessing":     "Procesando...",
				"sLengthMenu":     "Mostrar _MENU_ registros",
				"sZeroRecords":    "No se encontraron resultados",
				"sEmptyTable":     "Ningún dato disponible en esta tabla",
				"sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":    "",
				"sSearch":         "Buscar:",
				"sUrl":            "",
				"sInfoThousands":  ",",
				"sLoadingRecords": "Cargando...",
				"oPaginate": {
				    "sFirst":    "Primero",
				    "sLast":     "Último",
				    "sNext":     "Siguiente",
				    "sPrevious": "Anterior"
				},
				"oAria": {
				    "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
				    "sSortDescending": ": Activar para ordenar la columna de manera descendente"
				}
			}
		});
	}

	// Extra APT validator translations
	if ('undefined' !== typeof $.validator) $.extend($.validator.messages, {
		// Extra for apt
		credit_limit: "The credit limit should be between 250k and 150M.",
		grace_holiday_period: "The grace period should be lower than the term in months.",
		term_grace_leasing: "The term minus grace period should always be a multiple of payment frequency.",
		max_term_leasing: "The term minus grace period should not exceed 240 months (20 years).",
		max_term_factoring: "The term should not exceed 1200 months (100 years).",
		net_principal_amount: "The sum of down payment and residual value should be lower than the net principle amount.",
		zero: "This field must be greater than zero."
	});

}(jQuery);
